module.exports = __webpack_public_path__ + "static/media/autMenores.696f78d9.pdf";